import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import api from "../../services/api";
import { clearStats, getUserStats } from "./actions";

export const fetchUsersByTenant = createAsyncThunk(
  "userStats/fetchUsersByTenant",
  async (_, { rejectWithValue }) => {
    try {
      const route = "/activedtasks/tenant";
      const response = await api.get(route);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  },
);
const initialState = {
  doing: [],
  done: [],
  users: [],
  status: "idle",
};

const userStatsReducer = createReducer(initialState, {
  [fetchUsersByTenant.pending]: (state, action) => {
    state.status = "loading";
  },
  [fetchUsersByTenant.fulfilled]: (state, action) => {
    state.status = "succeeded";
    state.users = action.payload;
  },

  [getUserStats]: (state, action) => {
    state.doing = action.payload.doing;
    state.done = action.payload.done;
  },
  [clearStats]: (state) => {
    state.doing = [];
    state.done = [];
    state.users = [];
    state.status = "idle";
  },
});

export default userStatsReducer;
